import cNodata from './cNodata.vue';

export default {
  install(Vue) {
    Vue.component('cNodata', cNodata);
  },
};